import { render, staticRenderFns } from "./OwnerPart.vue?vue&type=template&id=91e7b37a&"
import script from "./OwnerPart.vue?vue&type=script&lang=js&"
export * from "./OwnerPart.vue?vue&type=script&lang=js&"
import style0 from "./OwnerPart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports